import React from 'react'
import { useState, useEffect } from "react";
import axios from "axios";
import BASE_URL from "../../BaseUrl.jsx";
export default function BestTeachersSection({message, setMessage, showMessage, setShowMessage,bestTeachers, setBestTeachers}) {

  const [teacherToEdit, setTeacherToEdit] = useState(null);
  const [showEditTeacherForm, setShowEditTeacherForm] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [idToDelete, setIdToDelete] = useState("");

  const editBestTeacher = () =>{
    axios.put(`${BASE_URL}/owner/update-best`, teacherToEdit, {withCredentials: true})
    .then((response)=>{
      setMessage("تم تعديل الوصف بنجاح");
      setShowMessage(true);
      bestTeachers.map((teacher)=>{
        if(teacher.teacherId === teacherToEdit.teacherId){
          teacher.description = teacherToEdit.description;
        }
      })
      setTeacherToEdit({});
      setShowEditTeacherForm(false);
    }).catch((error)=>{
      console.log(error);
    })
  }

  const deleteBestTeacher = ()=>{
    axios.delete(`${BASE_URL}/owner/delete-best?id=${idToDelete}`, {withCredentials: true})
    .then((response)=>{
      setMessage("تم حذف المدرس من قائمة افضل المدرسين");
      setShowMessage(true);
      setBestTeachers(bestTeachers.filter((teacher)=> teacher.teacherId !== idToDelete));
      setIdToDelete("");
      setShowDeleteConfirmation(false);
    }).catch((error)=>{
      console.log(error);
    })
  }

  useEffect(()=>{
    axios.get(`${BASE_URL}/owner/best-teachers`,{withCredentials: true})
    .then((response)=>{
      setBestTeachers(response.data);
    }).catch((error)=>{
      console.log(error);
    })
  }, []);



  return(
    <div className= 'admins-section-container'>
    <h2>افضل المدرسين</h2>
      <table className='admins-table'>
        <thead>
          <tr>
            <th>حذف</th>
            <th>تعديل</th>
            <th>الاسم</th>
          </tr>
        </thead>
        <tbody>
          {bestTeachers.map((teacher)=>{
            return(
              <tr key={teacher.teacherId}>
                <td>
                  <button className='delete-admin-button' onClick={()=>{
                    setIdToDelete(teacher.teacherId);
                    setShowDeleteConfirmation(true);
                  }}>حذف</button>
                </td>
                <td>
                  <button className='edit-admin-button' onClick={()=>{
                    setTeacherToEdit(teacher);
                    setShowEditTeacherForm(true);
                  }}>تعديل</button>
                </td>
                  <td>{teacher.name}</td>
              </tr>
            )
          }
        )}
        </tbody>
      </table>

      {showEditTeacherForm&&(
                <div className="overlay">
                <div className='admin-details-form' dir="rtl">
                    <h2>تعديل الوصف</h2>
                    <lable>الوصف</lable>
                    <textarea type="text" value={teacherToEdit.description} onChange={(e)=>{setTeacherToEdit({...teacherToEdit, description:e.target.value})}} />
                    <div className='edit-admin-buttons'>
                        <button className="edit-admin-button" onClick={()=>{
                            editBestTeacher();
                            setShowEditTeacherForm(false);
                        }}>تم</button>
                        <button onClick={()=>{
                            setTeacherToEdit(null);
                            setShowEditTeacherForm(false);
                        }}>إلغاء</button>

                    </div>

                </div>
                </div>
                )}

        { showDeleteConfirmation && (
                <div className="overlay">
                    <div className="delete-admin-confirmation">
                        <h3>هل أنت متأكد أنك تريد حذف هذا المدرس من قائمة افضل المدرسين؟</h3>
                        <div className="edit-admin-buttons">
                        <button onClick={() => deleteBestTeacher()}>نعم</button>
                        <button onClick={() => setShowDeleteConfirmation(false)}>لا</button>
                        </div>
                    </div>
                </div>
            )}
    </div>
  )
}